
<template>
  <div class="main">
    <Header
      :logo-white="false"
      :button="true"
      :background="true"
      :showNav="true"
    />
    <div class="flex-column flex-grid--full">
      <div
        class="flex-column flex-grid--full align-center background"
        @click.stop.prevent="openModal()"
      >
        <div class="flex-column flex-grid--full align-center adres">
          <h1 class="blog-white l-mb-6">
            <span>Steden in {{ provincy }} </span>
          </h1>

          <!-- <button
            class="btn-orange text-center"
            @click.stop.prevent="openModal(`alles`)"
          >
            Meer informatie
          </button> -->
        </div>
      </div>

      <div class="flex-grid-full justify-center">

        <!-- {{ provincyList }} -->
        <div class="wrapper">
          <div class="flex-column flex-grid l-mb-6">
            <h2>Voor de volgende steden in {{ provincy }} hebben wij een beschrijving gemaakt</h2>
            <p>Elke dag vullen we onze gegevens aan, dus meer steden zullen spoedig volgen.</p>
          </div>
          <div
            v-for="(city, i) in provincyList"
            :key="i"
            @click.stop.prevent="openModal(city.stad)"
          >
            <Step
              :step-as-link=false
              :step-summary=city.stad
              StepTitle="Beschrijving"
              :step-detail= "truncatedDescription(city.stadBeschrijving)"
              :button=true
              buttonTekst="Lees verder..."
            />
          </div>

          <div class="bg--grey wrapper onder">
            <h3 class="text-center">
              Op zoek naar een huurwoning? 
            </h3>
            <p class="text-center">
              Vind je nieuwe huurwoning in {{ stad }} of ergens anders in Nederland.
            </p>
            <div class="text-center">
              <a v-if="stad === 'Amsterdam'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123322&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Amsterdam</a>
              <a v-if="stad === 'Eindhoven'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123326&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Eindhoven</a>
              <a v-if="stad === 'Rotterdam'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123321&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Rotterdam</a>
              <a v-if="stad === 'Utrecht'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123323&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Utrecht</a>
              <a v-if="stad === 'Den Haag'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123324&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Den Haag</a>
              <a v-if="stad === 'Groningen'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123325&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Groningen</a>
              <a v-if="stad === 'Arnhem'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123330&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Arnhem</a>
              <a v-if="stad === 'Zwolle'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123331&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Zwolle</a>
              <a v-if="stad === 'Haarlem'" class="btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1123334&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow">Huurwoningen in Haarlem</a>
            </div>
            <div class="text-center">
              <a class="text-center btn btn-orange l-mt-3" href="https://tc.tradetracker.net/?c=25727&amp;m=1128957&amp;a=480276&amp;r=&amp;u=" target="_blank" rel="sponsored nofollow"> Huurwoning marktplaats </a>
            </div>
          </div>
        </div>
        
      </div>
      <Footer />
    </div>
    <CityStreetModal 
      v-if="stateModal" 
      :stadJson = provincyList
      :starter = starter
      :provincy = true
    />
  </div>
</template>


<script>
import { mapGetters, mapState } from "vuex";
import Header from "@/components/ComponentHeader";
import CityStreetModal from "@/components/ComponentCityStreetDialog";
import Step from "@/components/ComponentStep";
import Footer from "@/components/ComponentFooter";
import axios from 'axios';

export default {
  name: 'provincyPagina',
  components: {
    Header,
    CityStreetModal,
    Step,
    Footer
  },
  props: {
    provincy: {
      type: String,
      required: true,
      default: ""
    }
  },
  data () {
    return {
      loading: false,
      error: null,
      provincyList: {},
      starter: "",
    }
  },
  computed: {
    ...mapGetters(["getFunnel_toelichting"]),
    ...mapState({
      stateModal: state => state.openModal,
    })
  },
  mounted() {
    this.waitForLCP();
  },
  methods: {
    truncatedDescription(str) {
      return str.substring(0, 150) + "  ....";
    },
    openModal(straat) {
      this.starter = straat;
      this.$store.dispatch("toggleModal", !this.stateModal);
    },
    waitForLCP() {
      // Controleer eerst of PerformanceObserver beschikbaar is in de browser
      if ('PerformanceObserver' in window && 'largestContentfulPaint' in window.PerformanceObserver.supportedEntryTypes) {
        const observer = new PerformanceObserver((entryList) => {
          const entries = entryList.getEntries();
          // LCP bereikt, trigger Vue.js-code
          if (entries.length > 0 && entries[entries.length - 1].entryType === 'largestContentfulPaint') {
            this.executeAfterLCP();
            observer.disconnect();  // Stop met het observeren zodra LCP is bereikt
          }
        });

        // Begin met het observeren van de LCP-gebeurtenis
        observer.observe({ type: 'largest-contentful-paint', buffered: true });
      } else {
        // Als PerformanceObserver niet beschikbaar is, voer dan de code onmiddellijk uit
        this.fetchData();
      }
    },
    async fetchData() {
      this.loading = true; // Zet de loading status aan
      this.error = null;   // Reset eventuele eerdere fouten

      axios.defaults.headers.common['x-api-key'] = process.env.VUE_APP_GATEWAY_API;
      axios.defaults.responseType = 'json';

      const params = {
        provincyName: this.provincy.charAt(0).toUpperCase() + this.provincy.slice(1),
      };
      
      try {
        // Maak de API-aanroep
        const response = await axios.get('https://0ovja4ep62.execute-api.eu-west-2.amazonaws.com/' + process.env.NODE_ENV + '/getCitiesByProvincyName', { params});
        
        // Sla de opgehaalde data op in de component state
        this.provincyList = response.data['body-json'].body;
        
      } catch (err) {
        // In geval van een fout, sla de fout op
        this.error = 'Er is een fout opgetreden bij het ophalen van de data.';
      } finally {
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.background {
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  background-color: #94b0d3;
  height: 450px;
  margin-bottom: 40px;
}

.adres {
  text-transform: uppercase;
  color: #fff;
  text-transform: uppercase;
  margin-top: 5%;
}

.overlap {
  margin-top: -15%;
}

.intro {
  color: #F2F2F2;
  transform: translateY(-110%);
}

.action-blok {
  position: absolute;
  top: 22%;
  right: 20%; 
  background-color: #F2F2F2;
  padding: 25px;
  max-width: 50%;
}
.onder {
  margin-bottom: 64px;
}

.displayBox {
  padding: 2% 10%;
  margin: 64px;
}

.step__title {
  font-size: 32px;
  display: inline-block;
  margin-left: 24px;
}

.content:not(:last-child) {
  margin-bottom: 64px;
}

h4 {
  font-weight: bold;
}
.flex-grid {
  padding-bottom: 32px;
}
.bannerFrame {
  margin-top: -18%;
}

@media (min-width: 600px) and (max-width: 1023px) {

}

@media (min-width: 240px) and (max-width: 720px) {

  .background {
    height: 400px;
  }
  .adres {
    margin-top: 20%;
  }
  .action-blok {
    position: relative;
    background-color: #F2F2F2;
    padding: 40px;
  }
  .intro_box {
    position: static;
    transform: translateY(-440px);
    width: 90%;
    margin: 5%;
  }
  .content {
    margin-bottom: 20px;
  }
  .flex-grid {
    margin: 0 2%;
    padding-bottom: 32px;
  }
  .displayBox {
    padding: 2% 2%;
    margin: 64px 0;
  }
  .bannerFrame {
    margin-top: -45%;
  }
}
</style>
